<template lang="pug">
.personal-advice
    md-card(style="padding-bottom:16px")
        md-card-header
            .md-title(style="color: #012C58;") {{$t('personal.request')}}
        md-card-content
            p(style="color: #012C58;") {{$t('personal.info')}}
        md-card-actions
            span(style="flex:1;")
            md-button.md-raised.md-primary(@click.native="expert=true" style="color: #012C58;") Ask the Expert
    ask-the-expert(:show.sync="expert" :ration="ration" :step="3")
</template>
<script>

export default {
  components: {
    AskTheExpert: () => import('@/components/AskTheExpert')
  },
  props: {
    ration: { type: Object, default: () => ({}) }
  },
  data: () => {
    return {
      expert: false
    }
  }
}
</script>
<style scoped>
.md-card {
    margin: 0px;
}
.md-card {

    padding: 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/PersonalAdvice.vue